import { render, staticRenderFns } from "./PurchaseComission.vue?vue&type=template&id=76c52fb1&scoped=true"
import script from "./PurchaseComission.vue?vue&type=script&lang=js"
export * from "./PurchaseComission.vue?vue&type=script&lang=js"
import style0 from "./PurchaseComission.vue?vue&type=style&index=0&id=76c52fb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c52fb1",
  null
  
)

export default component.exports